<template>
  <div class="w-100">
    <b-alert
      :show="!!errorHandlingMessage"
      variant="danger"
      dismissible
      >{{ errorHandlingMessage }}</b-alert
    >
    <b-button v-bind="localBtnProps">{{ buttonText }} </b-button>
  </div>
</template>

<script>
  import { suppliosApi } from '../../js/api-service';
  import { errorHandling } from '../../js/custom-vue-mixins';

  export default {
    name: 'GeneralTenantFileDownloadBtn',
    components: {},
    mixins: [errorHandling],
    props: {
      slug: {
        type: String,
        required: true,
      },
      buttonProps: {
        type: Object,
        default: () => {
          return {};
        },
      },
      buttonText: {
        type: String,
        default: 'Download',
      },
    },
    data: function () {
      return {
        errorMsg: 'Error',
        error: false,
        loading: false,
        defaultButtonProps: {
          variant: 'primary',
          size: 'md',
          block: false,
          download: true,
          target: '_blank',
        },
        fileData: {}, // serialized file data from backend
      };
    },
    computed: {
      fileUrl() {
        return this.fileData.url ?? '';
      },
      localBtnProps() {
        return { disabled: !this.fileUrl, ...this.defaultButtonProps, ...this.buttonProps, href: this.fileUrl };
      },
    },
    mounted() {
      this.getFile();
    },
    methods: {
      // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
      async getFile() {
        this.loading = true;
        let resp;
        try {
          resp = await suppliosApi.generalTenantFile.get_by_slug(this.slug);

          //  'id',
          // 'tenant',
          // 'created',
          // 'modified',
          // 'title',
          // 'slug',
          // 'is_image',
          // 'is_public',
          // 'url',  # gets the URL from FileField/ImageField
        } catch (error) {
          // for these, if no response, that is likely no permission or not found...
          // log error but just don't show anything, let everything collapse
          //this.apiErrorHandler(error);
          console.error(`Got error when trying to get file in GeneralTenantFileDownloadBtn component with slug ${this.slug}`);
          console.error(error);
        }
        if (resp && resp.data) {
          this.fileData = resp.data;
        }
        this.loading = false;
      },
    },
  };
</script>

<style></style>
